import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore.js';

export function RequireRole({ role }) {
  const usuario = useAuthStore((s) => s.usuario);
  if (!usuario || usuario.rol !== role) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
